// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c577470e","977":"46d9dd23"}[chunkId] + ".chunk.js";
};